import { CustomParameterState } from '@app/core/store/custom-parameter/custom-parameter.type';

export const CUSTOM_PARAMETER_INITIAL_STATE: CustomParameterState = {
  parameters: [],
  loading: false,
  error: null
};
